<script>
export default {
  name: 'AlertModal',
  props: {
    status: {
      type: String,
      default: 'success'
    },
    message: {
      type: String,
      default: ''
    },
  },
  created () {
   
  },
  methods: {
    closeModal () {
      this.$emit('onClose')
    }
  }
}
</script>

<template>

    <!-- MODAL AREA START (Add To Cart Modal) -->
     <div>
    <div class="ltn__modal-area ltn__add-to-cart-modal-area">
        <div class="modal fade show" id="add_to_cart_modal" tabindex="-1" style="display:block;">
            <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" @click="closeModal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                         <div class="ltn__quick-view-modal-inner">
                             <div class="modal-product-item">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="modal-product-img">
                                           
                                        </div>
                                         <div class="modal-product-info">
                                          
                                            <p class="added-cart">
                                                <i v-if="status == 'success'" class="fa fa-check-circle"></i>  {{ message }}</p>
                                            <div class="btn-wrapper">
                                                <button type="button" @click="closeModal()"  class="theme-btn-1 btn btn-effect-1">Close</button>
                                            </div>
                                         </div>
                                       
                                    </div>
                                </div>
                             </div>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
    </div>
    <!-- MODAL AREA END -->
</template>



// WEBPACK FOOTER //
// src/components/shared/AlertModal.vue